export const DEBUG_VERIFIED_OVERRIDE_STORAGE_KEY = 'debug-verified-override';

export type VerificationOverride = 'default' | 'verified' | 'unverified';

export const VERIFICATION_OVERRIDE_OPTIONS: VerificationOverride[] = [
  'default',
  'verified',
  'unverified',
];

export const VERIFICATION_OVERRIDE_LABELS: Record<VerificationOverride, string> = {
  default: 'Use default behavior',
  verified: 'Force verified',
  unverified: 'Force unverified',
};

export function getVerificationOverride(): VerificationOverride {
  try {
    const value = localStorage.getItem(DEBUG_VERIFIED_OVERRIDE_STORAGE_KEY);
    if (value === 'verified' || value === 'unverified') return value;
  } catch {}

  return 'default';
}

export function setVerificationOverride(value: VerificationOverride): void {
  try {
    localStorage.setItem(DEBUG_VERIFIED_OVERRIDE_STORAGE_KEY, value);
  } catch {}
}

export function getDebugVerifiedOverride(): boolean | undefined {
  if (import.meta.env.VITE_ENABLE_MOCKS !== 'true') return undefined;

  const value = getVerificationOverride();
  if (value === 'verified') return true;
  if (value === 'unverified') return false;

  return undefined;
}
